import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import type { FC, ReactNode } from 'react';
import { useEffect } from 'react';
import { useAuthStore } from '@/common/stores/authStore';
import { useUserStore } from '@/user/stores/userStore';

interface AuthenticatedProps {
  children: ReactNode;
}

export const Authenticated: FC<AuthenticatedProps> = (props) => {
  const { children } = props;
  const router = useRouter();
  const { isSignedIn, goToSignIn: signIn } = useAuthStore();
  const { currentWorkspace } = useUserStore();
  const hasCurrentWorkspace = currentWorkspace !== null;

  useEffect(() => {
    if (!router.isReady) {
      return;
    }

    if (!isSignedIn) {
      signIn();
    }
  }, [router.isReady]);

  return isSignedIn && hasCurrentWorkspace ? <>{children}</> : <></>;
};

Authenticated.propTypes = {
  children: PropTypes.node
};
